import { FC, useState } from "react";
import { AttributeQueryStatement, QueryType, SegmentsSettingsType, ConditionalSegmentsSettings, QueryStatement, SegmentsSettings } from "reducers/flow-builder.reducer";
import { InlineForm, SuitableInputFiled } from "./common";
import { useFormMapLoader } from "./useFormFieldsHook";
import { checkAndCombiningSubfields, convertFieldToSegmentStatement, getOperatorLabel } from "./utils";

type PlainFieldType = any
interface StaticFormProps {
  settings: SegmentsSettings;
  isSegmentSettings?: boolean;
  isMultisplitBuilder?: boolean;
  isSubBuilderChild?: boolean;
  shouldShowErrors?: boolean;
  queryErrorsActions?: {
    add: (str: string) => void;
    remove: (str: string) => void;
  };
  onSubBuilderUngroup?: (statements: QueryStatement[]) => void;
  onSettingsChange: (
    settings: ConditionalSegmentsSettings | SegmentsSettings
  ) => void;
}

const StaticForm: FC<StaticFormProps> = (props: StaticFormProps) => {
  const { fields, setFields, isLoading: isLoadingFields } = useFormMapLoader()
  const onUpdateRootFieldsStatements = (changedFields: AttributeQueryStatement[]) => {
    const _fields = checkAndCombiningSubfields(changedFields)
    const filedStatements = _fields
      .map(field => convertFieldToSegmentStatement(field))
      .flat()
      .filter(Boolean) as AttributeQueryStatement[];

    const updatedSettings = {
      type: SegmentsSettingsType.CONDITIONAL,
      query: {
        type: QueryType.ALL,
        statements: filedStatements
      }
    } as ConditionalSegmentsSettings;
    props.onSettingsChange(updatedSettings);
  }

  const handleFieldChange = (field: any, value: string | string[]) => {
    const isExist = fields.find((f) => f.key === field.key);
    let newFields = [];
    if (!value) {
      return;
    }
    if (!isExist) {
      newFields = [...fields, { ...field, value }] as PlainFieldType[];
    } else {
      newFields = fields.map((f) => {
        if (f.key === field.key) {
          return {
            ...f,
            value: Array.isArray(value) ? value : value
          }
        }
        return f;
      }
      ) as PlainFieldType[];
    }
    setFields(newFields)
    onUpdateRootFieldsStatements(newFields);
  }


  return (
    <div className="static-form">
      <div className="font-normal text-[14px] leading-[22px]">
        All of the following conditions match
      </div>
      {isLoadingFields ? 'Loading' : fields.map((field: any) => {
        const operatorLabel = getOperatorLabel(field.operator);
        return (
          <InlineForm key={field.key}>
            <div className="text-[14px] leading-[22px] text-[#111827] min-w-[80px]">
              <div className="flex gap-[10px] w-[160px] items-center font-[500] text-ellipsis">
                {field.label}
              </div>
            </div>
            <div className="text-[#713F12] bg-[#FEF9C3] min-w-[50px] z-[1] text-center mr-[10px] py-[2px] px-[11.5px] rounded-[14px] font-roboto font-normal text-[14px] leading-[22px]">
              {operatorLabel}
            </div>
            <div className="flex gap-[10px] relative items-center flex-wrap">
              <SuitableInputFiled
                field={field}
                onChange={(value: any) => handleFieldChange(field, value)}
              />
            </div>
          </InlineForm>
        )
      })}
    </div>
  )
}

export default StaticForm;